export const SET_AI_MODELS = "SET_AI_MODELS";
export const SET_ACTIVE_AI_MODELS = "SET_ACTIVE_AI_MODELS";
export const SET_AI_MODEL_CONFIGS = "SET_AI_MODEL_CONFIGS";
export const IS_AI_MODEL_CONFIG_UPDATING = "IS_AI_MODEL_CONFIG_UPDATING";
export const UPDATE_AI_MODEL_CONFIGS = "UPDATE_AI_MODEL_CONFIGS";
